import React, { Component } from 'react';

export default class Top5 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carreras: [],
    };
  }

  componentDidMount() {}

  render() {
    // const carreras = this.props.carreras.map((c,ci) => {
    //   return <li key={"carreras-" + ci} className="lista-numero">{ c }</li>
    // })

    const carreras = this.props.carreras.map((c, ci) => {
      return (
        <li key={'carreras-' + ci} className='lista-numero'>
          <a href={c.link} target='_blank'>
            {c.name}
          </a>
        </li>
      );
    });

    return (
      <div class='padding-0 margin-top-20'>
        <h4 class='text-center title'>CARRERAS IDEALES</h4>
        <p dangerouslySetInnerHTML={{ __html: this.props.d_carreras }}></p>
        <h4 class='title'>
          <b>Top de recomendaciones:</b>
        </h4>
        <ol>{carreras}</ol>
        <p dangerouslySetInnerHTML={{ __html: this.props.d_carreras_2 }}></p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/Top5.jsx